import { render, staticRenderFns } from "./ClientCamerasTab.vue?vue&type=template&id=06856055&lang=html&"
import script from "./ClientCamerasTab.vue?vue&type=script&lang=js&"
export * from "./ClientCamerasTab.vue?vue&type=script&lang=js&"
import style0 from "./ClientCamerasTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports